import { MATCH_SCORE_RING_STROKE } from './RentalPortalMatchScoreRing.constants'

export function getMatchScoreRingGeometry(size) {
  const radius = (size - MATCH_SCORE_RING_STROKE) / 2

  return {
    center: size / 2,
    circumference: 2 * Math.PI * radius,
    radius,
  }
}

export function getMatchScoreRingArc({ circumference, ratio }) {
  return `${circumference * Math.min(Math.max(ratio, 0), 1)} ${circumference}`
}
